fetchCancelFns